import {
  Button, Checkbox, Dialog, DialogActions, DialogContent, Divider, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { checkHomewhiz } from 'src/utils/storage/StartWorkOrder';
import {
  setDefectFilterKey, setLabourSelection, setMaterialSelection, setSelection
} from '../../store/actions';

const useStyles = makeStyles({
  table: {
    width: '100%',
    minHeight: 500,
  },
});

const DefectTable = (props) => {
  const classes = useStyles();
  const { selected } = props.defects;
  const { t } = useTranslation('work_order');
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState('');
  const [showTable, setshowTable] = React.useState(false);
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add
      newSelected = [...selected, name];
      const kul_hizmet_kodu = props.defects.defectsTable[name].UserCode;
      const hizmet_isciligi = props.labours.Data.filter((d) => d.LabourCode === kul_hizmet_kodu);
      if (hizmet_isciligi.length > 0) {
        props.setLabourSelection(name, [kul_hizmet_kodu]);
      }
      if (kul_hizmet_kodu === '514') {
        if (checkHomewhiz(false)) {
          setAlertMsg('Ürün Homewhiz özelliklidir. Homewhiz kurulumunu yapınız!..');
          setAlertOpen(true);
        }
      }
    } else {
      // Remove
      newSelected = [...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1)
      ];
      props.setLabourSelection(name, []);
      props.setMaterialSelection(name, []);
    }
    props.setDefectFilterKey('', props.defects.level1Selected, props.defects.level2Selected);
    props.setSelection(newSelected);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const Level1Search = (Param, Type) => {
    props.setDefectFilterKey(props.defects.filterKey, Param, Type);
    setshowTable(false);
  };


  const highlight = (text) => (
    <Highlighter
      searchWords={[props.defects.filterKey]}
      autoEscape
      textToHighlight={text}
    />
  );

  const LevelSearch = Value => {
    // props.changeFilter(true);
    props.setDefectFilterKey(props.defects.filterKey, props.defects.level1Selected, Value);
    setshowTable(true);
  };

  

  return (
    <TableContainer className={classes.table} component={Paper}>
      <Select
        native
        value={props.defects.level1Selected}
        // onChange={(e) => props.setDefectFilterKey(props.defects.filterKey, e.target.value, 0)}
        onChange={(e) => Level1Search(e.target.value, 0)}
        fullWidth
      >
        <option value={0}>{t('lblAllCatagoryLevel1')}</option>
        {props.defects.level1.map((l) => <option value={l.level1Id}>{l.level1Desc}</option>)}
      </Select>
      <Divider />
      <Select
        native
        value={props.defects.level2Selected}
        onChange={e => LevelSearch(e.target.value)}
        fullWidth
      >
        <option value={0}>{t('lblAllCatagoryLevel2')}</option>
        {props.defects.level2Filtered.map((l) => <option value={l.level2Id}>{l.level2Desc}</option>)}
      </Select>
      {showTable
        ? (
          <Table size="small" aria-label="defect table">
            <TableHead>
              <TableRow>
                <TableCell>
                  {t('Hizmet')}
                  {' '}
                </TableCell>
                <TableCell>#</TableCell>
              </TableRow>
            </TableHead>
            { showTable
              ? (
                <TableBody>
                  {
            (props.defects.filtered) && props.defects.filtered.sort((s) => (isSelected(s.Code) ? -1 : 1)).map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;
              const isItemSelected = isSelected(row.Code);
              return (
                <TableRow
                  onClick={(event) => handleClick(event, row.Code)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={row.Code}
                  selected={isItemSelected}
                >
                  <TableCell component="th" scope="row">
                    <b>{highlight(row.UserCode)}</b>
                    {' '}
                    {highlight(row.DefectDesc)}
                  </TableCell>
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      checked={isItemSelected}
                      inputProps={{ 'aria-labelledby': labelId }}
                    />
                  </TableCell>
                </TableRow>
              );
            })

          }
                </TableBody>
              )
              : <div />}
          </Table>
        )
        : ''}
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      >
        <DialogContent>
          <Typography variant="h6" component="h4">
            {alertMsg}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </TableContainer>

  );
};


const mapStateToProps = (state) => ({
  defects: state.defectReducer,
  labours: state.labourReducer,
});

const mapDispatchToProps = {
  setSelection,
  setLabourSelection,
  setMaterialSelection,
  setDefectFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefectTable);
